<template>
  <div>
    <form
      autocomplete="off"
      class="a-form-column m-tinymce-primary"
      name="create-notice-form"
      @submit.prevent="updateContenidoEntregable"
    >
      <AtomSelectPrimary
        v-model.number="entrega"
        v-show="entregable.entregable.tipo === 'mensaje'"
        :elements="tiposDeEntrega"
        :inputError="$v.entrega.$error"
        keyField="id"
        :label="$t('mEditionAssetSendingOfDeliverablesEdit.inputs.entrega.label')"
        :messageError="messageErrorEntrega"
        name="entrega"
        textField="nombre"
        @blur="$v.entrega.$touch()"
      />

      <transition name="a-transtion-slide">
        <AtomInputPrimary
          v-model.number="entregable.entregable.dia"
          v-show="entrega == 1"
          :disabled="entregable.entregable.tipo === 'nodo'"
          :inputError="$v.entregable.entregable.dia.$error"
          :label="$t('mEditionAssetSendingOfDeliverablesEdit.inputs.dia.label')"
          message=""
          :messageError="messageErrorDia"
          min="0"
          name="dia"
          type="number"
          @blur="$v.entregable.entregable.dia.$touch()"
        />
      </transition>

      <AtomInputPrimary
        v-model="entregable.entregable.asunto"
        :inputError="$v.entregable.entregable.asunto.$error"
        :label="$t('mEditionAssetSendingOfDeliverablesEdit.inputs.asunto.label')"
        :message="$t('mEditionAssetSendingOfDeliverablesEdit.inputs.asunto.message')"
        :messageError="messageErrorAsunto"
        name="asunto"
        type="text"
        @blur="$v.entregable.entregable.asunto.$touch()"
      />

      <AtomTinymcePrimary
        v-model="entregable.entregable.mensaje"
        :inputError="$v.entregable.entregable.mensaje.$error"
        :label="$t('mEditionAssetSendingOfDeliverablesEdit.inputs.mensaje.label')"
        :messageError="messageErrorMensaje"
        name="mensaje"
        @onBlur="$v.entregable.entregable.mensaje.$touch()"
      />

      <AtomButtonPrimary :button-primary="buttonPrimary"/>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionAssetSendingOfDeliverablesEdit',

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionAssetSendingOfDeliverablesEdit.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      diaInicial: 0,
      entrega: '',

      entregable: {
        academia: '',
        entregable: {}
      },

      tiposDeEntrega: [
        {
          id: 0,
          nombre: 'Inmediato'
        },

        {
          id: 1,
          nombre: 'Personalizar día'
        }
      ]
    }
  },

  validations: {
    entrega: {
      required
    },

    entregable: {
      entregable: {
        asunto: {
          maxLength: maxLength(255),
          minLength: minLength(5),
          required
        },

        dia: {
          minLength: minLength(0),
          required
        },

        mensaje: {
          required
        }
      }
    }
  },

  computed: {
    messageErrorAsunto () {
      return this.$validation.getValidationMessage('mEditionAssetSendingOfDeliverablesEdit', this.$v.entregable.entregable.asunto, 'asunto')
    },

    messageErrorDia () {
      return this.$validation.getValidationMessage('mEditionAssetSendingOfDeliverablesEdit', this.$v.entregable.entregable.dia, 'dia')
    },

    messageErrorEntrega () {
      return this.$validation.getValidationMessage('mEditionAssetSendingOfDeliverablesEdit', this.$v.entrega, 'entrega')
    },

    messageErrorMensaje () {
      return this.$validation.getValidationMessage('mEditionAssetSendingOfDeliverablesEdit', this.$v.entregable.entregable.mensaje, 'mensaje')
    }
  },

  watch: {
    entrega () {
      this.entregable.entregable.dia = this.entrega === 0 ? 0 : this.diaInicial
    }
  },

  created () {
    this.entregable.entregable = Object.assign({}, this.$store.getters.getAssetSelectedDeliverable)
    if (Object.values(this.entregable.entregable).length) {
      this.entregable.academia = this.$store.getters.getAcademyData.id
      this.entrega = this.entregable.entregable.dia === 0 ? 0 : 1
      this.diaInicial = this.entregable.entregable.dia
    } else {
      this.$router.push(`/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.sendingOfDeliverables.subject')}`)
    }
  },

  methods: {
    updateContenidoEntregable () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.update('contenido', 'updateContenidoEntregable', this.entregable, [this.$route.params.subid])
          .then(response => {
            this.$modal.updateData()
            this.$alerts.pushAlert('mEditionAssetSendingOfDeliverablesEdit', 'updateContenidoEntregable', 'success')
            this.$router.push(`/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.activation.subject')}/${this.$t('mEditionMenu.asset.activation.children.sendingOfDeliverables.subedition')}`)
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAssetSendingOfDeliverablesEdit', 'updateContenidoEntregable', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
